import React, { useContext, useEffect, useState } from 'react';
import { navigate } from '@reach/router';

import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
// import { Alert } from '@material-ui/lab';
import CaseFinderIcon from '@material-ui/icons/Search';
import DashboardIcon from '@material-ui/icons/Dashboard';
import Drawer from '@material-ui/core/Drawer';
import DiyReferralIcon from '@material-ui/icons/AddToHomeScreen';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import LinkIcon from '@material-ui/icons/Link';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import PostAddIcon from '@material-ui/icons/PostAdd';
import EventBusyIcon from '@material-ui/icons/EventBusy';
import FolderSharedIcon from '@material-ui/icons/FolderShared';
import FolderSpecialIcon from '@material-ui/icons/FolderSpecial';
import ForumIcon from '@material-ui/icons/Forum';
import Grid from '@material-ui/core/Grid'
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import HowToRegIcon from '@material-ui/icons/HowToReg';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import PersonIcon from '@material-ui/icons/Person';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import TransferWithinAStationIcon from '@material-ui/icons/TransferWithinAStation';

import appPaths from '../../../appPaths';
import AuthContext from '../../../services/firebase/AuthContext';
import { ApplicationName } from '../../Copyright';
import { DbxContext } from '../../../services/DbxContext';
import SignOut from '../../auth/SignOut';
import ToggleArchiveView from './ToggleArchiveView';
import FireDataContext from '../../../services/firebase/FireDataContext';
import version from '../../Version';
import Button from '@material-ui/core/Button'

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing(7) + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9) + 1,
        },
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
    rhsButton: {
        marginLeft: 'auto'
    },
}));

const MemberMiniMenu = ({ children }) => {
    const { currentUser: { uid, name, roles } } = useContext(AuthContext);
    const cache = useContext(DbxContext);
    const db = useContext(FireDataContext);
    const [serverVersion, setServerVersion] = useState();

    useEffect(() => {
        db.get({ path: `config/version`, context: 'MemberMiniMenu' })
            .then(v => {
                setServerVersion(v);
            })
            .catch(error => console.log(error));
    }, [db]);

    const classes = useStyles();
    const theme = useTheme();
    const [open, setOpen] = useState(Boolean(cache.read('menu_state')));

    const casework = 'casework';
    const admin = 'admin';
    const member = 'member';

    const menuItems = [
        { section: casework, label: 'Dashboard', key: 'arddss61na', icon: <DashboardIcon />, path: appPaths.casework.dashboard },
        { section: casework, label: 'Cases', key: 'ar53idt61na', icon: <CreateNewFolderIcon />, path: `/casework/info/${uid}` },
        { section: casework, label: 'Referrals', key: 'ar53gy61na', icon: <FolderSpecialIcon />, path: appPaths.casework.referrals },
        { section: casework, label: 'DIY Referral', key: 'agfdss61na', icon: <DiyReferralIcon />, path: '/casework/diy/referral' },
        { section: casework, label: 'Quotes', key: 'br53gy61na', icon: <ForumIcon />, path: appPaths.casework.quotes },
        { section: casework, label: 'Bookings', key: 'cr53gy61nb', icon: <FolderSharedIcon />, path: appPaths.casework.bookings },
        { section: casework, label: 'Invoices', key: 'dr53gy61ab', icon: <HomeWorkIcon />, path: appPaths.casework.timesheets },
        { section: admin, label: 'Invite Members', key: 'fr53gy61nc', icon: <PersonAddIcon />, path: appPaths.members.invite },
        { section: admin, label: 'Referrers', key: 'zz53gy61nd', icon: <HowToRegIcon />, path: appPaths.admin.organizations },
        { section: admin, label: 'Members', key: 'zz53gy66nd', icon: <SupervisorAccountIcon />, path: appPaths.admin.members },
        { section: member, label: 'Profile / Bio', key: 'fr53gy61ne', icon: <PersonIcon />, path: appPaths.members.profile },
        { section: member, label: 'Preferences', key: 'fr53fgx1ne', icon: <TransferWithinAStationIcon />, path: appPaths.members.preferences },
        { section: member, label: 'Calendar', key: 'fr53gy61nf', icon: <EventBusyIcon />, path: appPaths.members.calendar },
        { section: 'finance', label: 'Member Invoices', key: 'fr53kjhkj1nf', icon: <PostAddIcon />, path: '/finance/purchase_invoices' },
        { section: 'finance', label: 'Coop Invoices', key: 'fr53gy61xzssnf', icon: <PlaylistAddCheckIcon />, path: '/finance/sales_invoices' },
        { section: admin, label: 'Xero Referrers', key: 'fr53tuytuyssnf', icon: <LinkIcon color="primary" />, path: '/admin/finance/xorg' },
        { section: admin, label: 'Xero Members', key: 'fr53gy61xzsrte', icon: <LinkIcon color="secondary" />, path: '/admin/finance/xmembers' },
        { section: admin, label: 'Mail Log', key: 'fr53dgfdgfdzzz', icon: <MailOutlineIcon />, path: '/admin/mail' },
        { section: admin, label: 'Find a Case', key: 'fr5desfdgfdzzz', icon: <CaseFinderIcon />, path: '/admin/cases/search' },
        
    ];

    const handleDrawerOpen = () => {
        setOpen(true);
        cache.publish({
            topic: 'menu_state',
            value: true
        })
    };

    const handleDrawerClose = () => {
        setOpen(false);
        cache.publish({
            topic: 'menu_state',
            value: false
        })
    };

    // const title = serverVersion?.number > version.number ? `This version of TICIT is out of date. Please refresh this page to get version ${serverVersion.number}`
    //     : ApplicationName;

    return (
        <React.Fragment>
            {/* {
                serverVersion?.number > version.number &&
                <Alert severity="warning" variant="filled">This version of TICIT is out of date. Please refresh this page to get version {serverVersion.number}</Alert>
            } */}
            <div className={classes.root}>
                <CssBaseline />
                <AppBar
                    position="fixed"
                    className={clsx(classes.appBar, {
                        [classes.appBarShift]: open,
                    })}
                >
                    <Toolbar>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={handleDrawerOpen}
                            edge="start"
                            className={clsx(classes.menuButton, {
                                [classes.hide]: open,
                            })}
                        >
                            <MenuIcon />
                        </IconButton>
                        {
                            serverVersion?.number > version.number ?
                                <Button onClick={() => window.location.reload()}
                                    variant="contained" color="secondary" style={{ marginLeft: '1rem' }}>
                                    Please refresh this page to get version {serverVersion.number}
                                </Button>
                                :
                                <Typography variant="h6" noWrap>
                                    {ApplicationName} / {name} {roles?.includes('admin') && <SupervisorAccountIcon />}
                                </Typography>
                        }

                        <div style={{ marginLeft: 'auto' }}>
                            <Grid container spacing={1}>
                                <Grid item>
                                    <ToggleArchiveView />
                                </Grid>
                                <Grid item>
                                    <SignOut variant="outlined" color="inherit" />
                                </Grid>
                            </Grid>
                        </div>
                    </Toolbar>
                </AppBar>
                <Drawer
                    variant="permanent"
                    className={clsx(classes.drawer, {
                        [classes.drawerOpen]: open,
                        [classes.drawerClose]: !open,
                    })}
                    classes={{
                        paper: clsx({
                            [classes.drawerOpen]: open,
                            [classes.drawerClose]: !open,
                        }),
                    }}
                >
                    <div className={classes.toolbar}>
                        <IconButton onClick={handleDrawerClose}>
                            {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                        </IconButton>
                    </div>
                    <Divider />
                    <List>
                        {menuItems.filter(({ section }) => section === casework).map(({ label, key, icon, path }) => (
                            <ListItem button key={key} onClick={() => navigate(path || "#")}>
                                <ListItemIcon>{icon}</ListItemIcon>
                                <ListItemText primary={label} />
                            </ListItem>
                        ))}
                    </List>
                    <Divider />
                    <List>
                        {menuItems.filter(({ section }) => section === member).map(({ label, key, icon, path }) => (
                            <ListItem button key={key} onClick={() => navigate(path || "#")}>
                                <ListItemIcon>{icon}</ListItemIcon>
                                <ListItemText primary={label} />
                            </ListItem>
                        ))}
                    </List>
                    <Divider />
                    <List>
                        {roles.includes('admin') && menuItems.filter(({ section }) => section === admin).map(({ label, key, icon, path }) => (
                            <ListItem button key={key} onClick={() => navigate(path || "#")}>
                                <ListItemIcon>{icon}</ListItemIcon>
                                <ListItemText primary={label} />
                            </ListItem>
                        ))}
                    </List>
                    <Divider />
                    <List>
                        {menuItems.filter(({ section }) => section === 'finance').map(({ label, key, icon, path }) => (
                            <ListItem button key={key} onClick={() => navigate(path || "#")}>
                                <ListItemIcon>{icon}</ListItemIcon>
                                <ListItemText primary={label} />
                            </ListItem>
                        ))}
                    </List>
                </Drawer>
                <main className={classes.content}>
                    <div className={classes.toolbar} />
                    {children}
                </main>
            </div>

        </React.Fragment>
    );
}

export default MemberMiniMenu;